import validation from '@/mixins/validation';
import { email, required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  name: 'HomeSubscribe',
  mixins: [validation],
  data() {
    return {
      payload: {
        email: ''
      },
      loading: false,
      successMessage: '',
      validationErrors: {}
    };
  },
  validations() {
    return {
      payload: {
        email: {
          required,
          email
        }
      }
    };
  },
  computed: {
    emailErrors() {
      return this.computeErrors('payload', 'email', {
        required: 'newsletter.emailError',
        email: 'newsletter.emailError'
      });
    }
  },
  methods: {
    ...mapActions({
      esputnikSubscribe: 'esputnik/SUBSCRIBE'
    }),
    async getRecaptchaToken() {
      await this.$recaptchaLoaded();
      return this.$recaptcha('subscribe');
    },
    onInput() {
      this.successMessage = '';
      if (this.validationErrors.email) {
        this.validationErrors = {};
      }
    },
    async subscribeToEsputnik() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.validationErrors = {};
      this.successMessage = '';
      this.loading = true;

      try {
        const recaptchaToken = await this.getRecaptchaToken();
        await this.esputnikSubscribe({
          email: this.payload.email,
          recaptcha_token: recaptchaToken
        });

        this.successMessage = this.$t('newsletter.success');
        this.payload.email = '';
        this.$v.$reset();
      } catch (error) {
        this._handleSubscribeError(error);
      } finally {
        this.loading = false;
      }
    },
    _handleSubscribeError(error) {
      const errors = error?.data?.errors;
      if (error?.status !== 422 || !errors) return;

      if (errors.email) {
        this.validationErrors = { email: [this.$t('newsletter.emailError')] };
        return;
      }

      if (errors.recaptchaToken) {
        return;
      }
    }
  }
};
